/* istanbul ignore file */
import React from 'react';
import { SecurityContextTemplate, SecurityContextCommonProps } from 'framework/authorization';
import { useEmployeeContractId } from 'domain/people/employee/contracts/employeeContractRouting';
import { useEmployeeService } from 'domain/shared/employee';

export const CONTRACTS_CONTEXT = 'CONTRACTS';

const EmployeeContractsContext = ({ permissionToCheck, children }: SecurityContextCommonProps) => {
  const { getGlobalPeopleManagementPermissions } = useEmployeeService();
  const id = useEmployeeContractId();

  return (
    <SecurityContextTemplate
      getPermissionsFunc={() => getGlobalPeopleManagementPermissions()}
      permissionToCheck={permissionToCheck}
      id={id}
      contextName={CONTRACTS_CONTEXT}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default EmployeeContractsContext;
